import { render } from "./App.vue?vue&type=template&id=1def2fb8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1def2fb8&lang=css"

import exportComponent from "/Users/ronnasat/S3/trueeye_backend_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__